import React from 'react';
import { FAQ_CONTENT_SCHEMA_URL, LTS_FAQ } from '../../constants/SEOConstants';

const FAQContent = () => {
  const { label, listItems } = LTS_FAQ;

  return (
    <div className="LTSPageCommon-FAQContent-wrapper">
      <h2 className="font22 latoBold appendBottom15">{label}</h2>
      <ol className="LTSPageCommon-FAQContent-ol" itemScope itemType={FAQ_CONTENT_SCHEMA_URL.faqPage}>
        {listItems.map((item, index) => (
          <li
            className="LTSPageCommon-FAQContent-li"
            key={`${item.question}-${index}`}
            itemProp="mainEntity"
            itemScope
            itemType={FAQ_CONTENT_SCHEMA_URL.question}
          >
            <div
              className="LTSPageCommon-FAQContent-question"
              itemProp="name"
              dangerouslySetInnerHTML={{ __html: item.question }}
            />
            <div
              className="LTSPageCommon-FAQContent-answer"
              itemProp="acceptedAnswer"
              itemScope
              itemType={FAQ_CONTENT_SCHEMA_URL.answer}
            >
              <div itemProp="text" dangerouslySetInnerHTML={{ __html: item.answer }} />
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default FAQContent;
